// extracted by mini-css-extract-plugin
export default {"newMessage":"NewMessage_newMessage__KS7N-","messageHeader":"NewMessage_messageHeader__eGJ+c","newMessageButtonRow":"NewMessage_newMessageButtonRow__kH7fK"};